import { render, staticRenderFns } from "./bxKbjlb.vue?vue&type=template&id=73451fbd&scoped=true"
import script from "./bxKbjlb.vue?vue&type=script&lang=js"
export * from "./bxKbjlb.vue?vue&type=script&lang=js"
import style0 from "./bxKbjlb.vue?vue&type=style&index=0&id=73451fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73451fbd",
  null
  
)

export default component.exports